<template>
  <div :class="homepage_class" id="home">
    <!--轮播图-->
    <el-carousel class="tophome" :interval="4000" :height="autoHeight_top">
      <el-carousel-item v-for="(item, index) of imageList" :key="index">
        <!-- item.img_url + '?x-oss-process=image/resize,m_fill,h_1080,w_1920' -->
        <el-image :src="
            item.img_url
          " fit="cover" class="swiper-img" :style="{ height: autoHeight_top }"></el-image>
        <div class="container-content">
          <h3 class="carousel-desc1">{{ item.title_one }}</h3>
          <h1 class="carousel-desc2">{{ item.title_two }}</h1>
          <div class="carousel-desc3">{{ item.content }}</div>
          <button class="carousel-button" style="color: #333;" v-if="homepage.is_show_banner_button" @click="handleContantBtnClick">
            了解更多
          </button>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!--关于我们-->
    <el-row class="about-us" v-if="homepage.aboutus_is_show">
      <div class="about-us-center">
        <h1 class="about-us-title-h1">{{ homepage.aboutus_title_two }}</h1>
        <div class="about-us-title-p">
          {{ homepage.aboutus_content }}
          <div style="overflow: hidden; margin-top: 30px;">
            <div>
              <span style="padding: 5px 6px;background-color: #135CCF;border-radius: 10px;font-size: 14px;">{{ homepage.evermen_two_title }}</span>
              <span style="color: #135CCF;font-size: 12px;margin-left: 10px;background: white;padding:5px;border-radius: 10px;">{{ homepage.evermen_two_content }}</span>
            </div>
            <div style="margin-top:20px">
              <span style="padding: 5px 6px;background-color: #135CCF;border-radius: 10px;font-size: 14px;">{{ homepage.evermen_three_title }}</span>
              <span style="color: #135CCF;font-size: 12px;margin-left: 10px;background: white;padding:5px;border-radius: 10px;">
                {{ homepage.evermen_three_content }}
              </span>
            </div>
          </div>
        </div>

        <div class="aboutList1">
          <div v-if="homepage.is_show_banner_button" class="aboutButton" @click="handleContantBtnClick">
            <img loading="lazy" src="https://wugecdn.steam.fun/resources/static/homepage_v2/aboutButton.png" />
          </div>

          <div class="aboutImg">
            <!-- autoHeight_about -->
            <el-carousel indicator-position="none" :height="autoHeight_about" arrow="always">
              <el-carousel-item v-for="(item, index) in JSON.parse(homepage.aboutus_img_url)" :key="index">
                <img loading="lazy" :src="
                    item + '?x-oss-process=image/resize,m_fill,h_550,w_1170'
                  " style="width: 100%;border-radius: 16px;object-fit: cover; height: auto;" />
                <!-- height: 338px -->
              </el-carousel-item>
              <!-- <el-carousel-item>
                <img loading="lazy" src="../../assets/image/zximg1.png"
                  style="width: 100%;border-radius: 16px;object-fit: cover; height: 338px;" />
              </el-carousel-item>
              <el-carousel-item>
                <img loading="lazy" src="../../assets/image/zximg2.png"
                  style="width: 100%;border-radius: 16px;object-fit: cover; height: 338px;" />
              </el-carousel-item> -->
            </el-carousel>
          </div>
        </div>
      </div>
    </el-row>

    <!--师资介绍-->
    <el-row class="teachers-wrapper-all" v-if="homepage.teacher_is_show">
      <div class="teachers-wrapper-center">
        <div id="teachinfo" class="teachers-wrapper">
          <h1 class="teacher-title-h1">{{ homepage.teacher_title_two }}</h1>

          <el-carousel indicator-position="outside" :height="autoHeight_teacher">
            <el-carousel-item v-for="(page, index) of pages" :key="index">
              <el-row class="teacher-list">
                <el-col style="padding: 10px" :span="6" v-for="item of page" :key="item.id">
                  <div class="bgTeacher">
                    <img loading="lazy" :src="
                        item.img_url +
                          '?x-oss-process=image/resize,m_fill,h_306,w_224'
                      " class="teacher-image" style="height:auto;object-fit: cover;" />
                    <!-- height:306px -->
                    <div class="teacher_desc">
                      <div class="desc_txt" v-html="item.desc"></div>
                    </div>

                    <div class="teacherBgButton">
                      <img loading="lazy" src="https://wugecdn.steam.fun/resources/static/homepage_v2/teacherNameButton.png" />
                      <div class="teacherName">{{ item.name }}</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </el-row>

    <!-- 课程体系 -->
    <el-row class="course-wrapper" v-if="homepage.system_is_show">
      <div class="course-wrapper-center">
        <el-row>
          <el-col :span="24">
            <div class="course-list-title-wrapper">
              <h1 class="course-list-title">
                {{ homepage.system_title_two }}
              </h1>
              <p class="course-list-title-p">
                {{ homepage.system_content }}
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="course-list-right">
              <el-carousel :interval="4000" type="card" :height="autoHeight_top_course">
                <el-carousel-item class="CarouselCourseInfo bgSubject" v-for="item in CourseInfo" :key="item.id">
                  <div style="padding: 10px; overflow: hidden;">
                    <div class="img-wrapper" style="border-radius: 20px; overflow: hidden;">
                      <img loading="lazy" class="course-img" style="height:auto;object-fit: cover;" :src="item.img_url" />
                      <!-- height:400px -->
                      <div class="course_desc">
                        <div class="desc_txt">
                          <div>{{ item.desc }}</div>
                          <div style="margin-top:10px;">{{ item.content }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>

    <!--教学理念-->

    <el-row class="TeachingIdea" v-if="homepage.idea_is_show">
      <div class="TeachingIdea-center">
        <el-row>
          <el-col :span="24">
            <div class="TeachingIdea-title-wrapper">
              <span class="TeachingIdea-title">{{
                homepage.idea_title_two
              }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" :xs="{span: 24}">
            <div class="TeachingIdea-left">
              <div class="TeachingIdea-img2-wrapper">
                <el-image class="TeachingIdea-img2" :src="homepage.idea_img_url"></el-image>
              </div>
            </div>
          </el-col>

          <el-col :span="12" :xs="{span: 24}">
            <div style="margin-top: 10%; padding-right: 10%">
              <el-row class="TeachingIdea-item-wrapper" :gutter="20">
                <el-col :span="12">
                  <div class="TeachingIdea-item">
                    <div class="TeachingIdea-item-iconbox el-icon-s-help"></div>
                    <div class="TeachingIdea-item-title">
                      {{ homepage.idea_one_title }}
                    </div>
                    <div class="TeachingIdea-item-desc">
                      {{ homepage.idea_one_content }}
                    </div>
                  </div>
                </el-col>

                <el-col :span="12">
                  <div class="TeachingIdea-item">
                    <div class="TeachingIdea-item-iconbox el-icon-s-management"></div>
                    <div class="TeachingIdea-item-title">
                      {{ homepage.idea_two_title }}
                    </div>
                    <div class="TeachingIdea-item-desc">
                      {{ homepage.idea_two_content }}
                    </div>
                  </div>
                </el-col>

                <el-col :span="12">
                  <div class="TeachingIdea-item">
                    <div class="TeachingIdea-item-iconbox el-icon-menu"></div>
                    <div class="TeachingIdea-item-title">
                      {{ homepage.idea_three_title }}
                    </div>
                    <div class="TeachingIdea-item-desc">
                      {{ homepage.idea_three_content }}
                    </div>
                  </div>
                </el-col>

                <el-col :span="12">
                  <div class="TeachingIdea-item">
                    <div class="TeachingIdea-item-iconbox el-icon-guide"></div>
                    <div class="TeachingIdea-item-title">
                      {{ homepage.idea_four_title }}
                    </div>
                    <div class="TeachingIdea-item-desc">
                      {{ homepage.idea_four_content }}
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>

    <!--为什么学编程-->
    <el-row class="whycode-wrapper-all" v-if="homepage.whylearn_is_show">
      <div class="whycode-wrapper-center">
        <el-row>
          <el-col :span="24">
            <div class="whycode-title-wrapper">
              <span class="whycode-title">
                {{ homepage.whylearn_title_two }}
              </span>
            </div>
          </el-col>
        </el-row>
        <div style="width:1200px; margin: 0 auto;">
          <el-carousel indicator-position="outside" :height="autoHeight_code" arrow="never">
            <el-carousel-item v-for="(page, index) of learncode_pages" :key="index">
              <el-row class="whycode-list">
                <el-col style="padding: 10px" :span="6" :xs="12" v-for="item of page" :key="item.id">
                  <div style="padding: 0!important;">
                    <div class="whycode-image-wrapper">
                      <div class="bck">
                        <div>
                          <img loading="lazy" :src="item.img_url" class="whycode-image" />
                        </div>
                        <div class="bcBgButton">
                          <img loading="lazy" src="https://wugecdn.steam.fun/resources/static/homepage_v2/bcxk.png" />
                          <div class="teacherName">{{ item.title }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="whycode-name">
                      <div class="whycode-desc" style="height:30px">
                        {{ item.content }}
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </el-row>

    <!--校园新闻-->
    <el-row class="news-wrapper-all" v-if="homepage.news_is_show">
      <div class="news-wrapper-all-center">
        <el-row>
          <el-col :span="24">
            <div class="news-title-wrapper">
              <span class="news-title">{{ homepage.news_title_one }}</span>
            </div>
          </el-col>
        </el-row>
        <div class="about-index">
          <div class="containersfq">
            <div class="fine-grained">
              <div class="content">
                <div class="left">
                  <div class="or-container">
                    <div class="box" :class="eleindex == i ? 'eleactive' : ''" v-for="(ele, i) in NewsList" :key="i" @mouseenter="enter(i, ele)" @mouseleave="out(i)">
                      <img loading="lazy" :src="
                          ele.img_url +
                            '?x-oss-process=image/resize,m_fill,h_375,w_570'
                        " style="object-fit: cover;" />

                      <div class="newdesc">
                        <div class="newdesc_txt" v-html="ele.content"></div>
                      </div>

                      <div class="wenb">
                        <div>{{ ele.title }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>

    <!--照片墙-->
    <el-row class="photo-wrapper-all" v-if="homepage.stu_is_show">
      <div class="photo-wrapper-center">
        <div class="photo-wrapper">
          <h1 class="photo-title-h1">{{ homepage.stu_title_two }}</h1>
          <el-carousel indicator-position="outside" :autoplay="false">
            <el-carousel-item v-for="(page, index) of stu_pages" :key="index">
              <el-row>
                <el-col style="padding: 30px;height: 100%;" :span="6" :xs="12" v-for="(item, index) of page" :key="index">
                  <div class="bgquan">
                    <img loading="lazy" :src="
                        item.img_url +
                          '?x-oss-process=image/resize,m_fill,h_250,w_250'
                      " style="width: 230px;border-radius: 50%;height: 222px;" />
                  </div>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </el-row>

    <!--大咖推荐-->
    <el-row class="bigname-wrapper" v-if="homepage.is_show_recommend">
      <div class="bigname-wrapper-center">
        <el-row>
          <el-col :span="24">
            <div class="bigname-title-wrapper">
              <span class="bigname-title">大咖推荐</span>
            </div>
          </el-col>
        </el-row>
        <div style="width: 308px; margin: 0 auto; margin-top: 50px;">
          <el-carousel :interval="4000">
            <el-carousel-item><img loading="lazy" src="https://wugecdn.steam.fun/resources/static/homepage_v2/abm.png" style="width: 100%;" /></el-carousel-item>
            <el-carousel-item><img loading="lazy" src="https://wugecdn.steam.fun/resources/static/homepage_v2/brgc.png" style="width: 100%;" /></el-carousel-item>
            <el-carousel-item><img loading="lazy" src="https://wugecdn.steam.fun/resources/static/homepage_v2/qbs1.png" style="width: 100%;" /></el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </el-row>

    <!--家长疑惑-->
    <el-row class="bignamesay-wrapper" v-if="homepage.is_show_problem">
      <div class="bignamesay-wrapper-center">
        <el-row>
          <el-col :span="24">
            <div class="bignamesay-title-wrapper">
              <span class="bignamesay-title">常见问题</span>
            </div>
          </el-col>
        </el-row>

        <el-row class="bignamesay-right-wrapper">
          <el-col :span="20" :offset="2">
            <div class="bignamesay-right">
              <div style="overflow: hidden;">
                <div class="iconwn "></div>
                <div class="colorTxt">
                  <div>怕孩子沉迷游戏?</div>
                  <div class="colorTxt1">
                    编程告诉孩子们游戏是怎么开发出来的，明白了程序员是怎么开发游戏的，这会让孩子站在一个更高的角度去看待网络游戏，避免沉迷游戏.
                  </div>
                </div>
              </div>
              <div style="overflow: hidden;margin-top: 30px;">
                <div class="iconwn "></div>
                <div class="colorTxt">
                  <div>数学不好？逻辑思维比较差?</div>
                  <div class="colorTxt1">
                    编程用游戏的方式，去锻炼孩子们的逻辑思维，抓住数学逻辑启蒙的黄金期，学好数学，锻炼逻辑思维能力吧.
                  </div>
                </div>
              </div>
              <div style="overflow: hidden;margin-top: 30px;">
                <div class="iconwn "></div>
                <div class="colorTxt">
                  <div>孩子学习上特别粗心?</div>
                  <div class="colorTxt1">
                    编程是不允许出现一点错误的，必须建立在一个细致严谨的态度之下，孩子们粗心的毛病也就迎刃而解了.
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>

    <!--FOOTER-->
    <el-row class="footer" v-if="homepage.footer_is_show">
      <div class="footer-center">
        <el-col :span="6" class="mobile-hidden">
          <div class="footer-us">
            <span class="footer-us-title">{{
              homepage.footer_aboutus_title
            }}</span>

            <div class="footer-us-content">
              {{ homepage.footer_aboutus_content }}
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="mobile-hidden">
          <div class="footer-link">
            <span class="footer-us-title">{{
              homepage.footer_match_title
            }}</span>

            <div class="footer-contant-link">
              <div v-for="item in FooterData" :key="item.id">
                <el-link :underline="false" :href="item.url" target="_blank">{{
                  item.title
                }}</el-link>
                <br />
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="12">
          <div class="footer-contant">
            <span class="footer-us-title">{{
              homepage.footer_contact_title
            }}</span>

            <div class="footer-contant-content">
              <div class="footer-contant-info">
                <span class="footer-icon el-icon-s-home"></span>
                {{ homepage.footer_contact_address }}
              </div>
              <div class="footer-contant-info">
                <span class="footer-icon el-icon-phone-outline"></span>
                {{ homepage.footer_contact_tel }}
              </div>
              <div class="footer-contant-info">
                <span class="footer-icon el-icon-user-solid"></span>
                {{ homepage.footer_contact_wechat }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="12">
          <div class="footer-qrcode">
            <span class="footer-us-title">{{ homepage.footer_wx_title }}</span>
            <div>
              <img loading="lazy" class="footer-qrcode-img" :src="homepage.footer_wx_img_url" />
            </div>
          </div>
        </el-col>

        <el-col :span="24" v-if="homepage.is_show_copy_right">
          <div class="copyright">
            <span style="font-size: 10px" class="copyright-content">
              Copyright © STEAM.FUN 2023. All Rights Reserved
            </span>

            |

            <a class="beian" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010302002038" target="_blank" style="color: #383838;margin-left:5px;">
              <img loading="lazy" style="width: 10px; height: 10px" src="https://wuge-homepage-resourse.oss-cn-beijing.aliyuncs.com/img/beian.png" />
              津公网安备 12010302002038号</a>
            |
            <a class="beian" href="https://beian.miit.gov.cn/" target="_blank" style="display: inline-block;font-size: 10px;font-weight: normal;color: #383838;margin-left: 5px;">
              津ICP备17004637号-4</a>
          </div>
        </el-col>
      </div>
    </el-row>

    <el-button v-if="!gonglixiao" style="position: fixed; right: 20px; bottom: 20px; z-index: 1000" type="danger" icon="el-icon-arrow-up" circle @click="goHome"></el-button>

    <!--联系我们弹框-->
    <!--
    <el-dialog class="contant-dialog" :visible.sync="dialogVisible" width="25%">
      <img loading="lazy" class="contant-img" :src="homepage.modal_img_url" />
    </el-dialog>
    -->
    <!-- 到期提醒 -->

    <div v-if="dialogVisible" class="tcBg">
      <div class="tc">
        <div class="iconx" @click="handleContantBtnClickC">
          <img loading="lazy" src="https://wugecdn.steam.fun/resources/static/homepage_v2/iconx.png" />
        </div>
        <div class="mp">
          <img loading="lazy" :src="
              homepage.modal_img_url +
                '?x-oss-process=image/resize,m_pad,h_200,w_200'
            " style="width: 100%;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import 'swiper/swiper-bundle.min.css'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getHomepage } from '@/api/homeset'

export default {
  name: 'home',
  // components: {
  //   swiper,
  //   swiperSlide
  // },
  data() {
    return {
      eleindex: 0,
      off_time1: '',
      newTime: '',
      off_time: '',
      swiperOptionTop: {
        direction: 'vertical',
        loopedSlides: 1,
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: true, //悬停停止切换
          disableOnInteraction: true,
        },
        loop: true,
        thumbs: {
          swiper: this.$refs.swiperThumbs,
        },
      },
      swiperOptionThumbs: {
        direction: 'vertical',
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: true, //悬停停止切换
          disableOnInteraction: true,
        },
        loop: true,
        loopedSlides: 1,
        freeMode: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        // touchRatio: 0.2,
        slideToClickedSlide: true,
      },

      autoHeight_top: '0px', //轮播图自适应高度
      autoHeight_top_course: '0px',
      autoHeight_teacher: '0px',
      autoHeight_code: '0px',
      autoHeight_photo: '0px',
      autoHeight_about: '0px',

      isschool: true,
      domain: '', //二级域名
      value: 5, //五星好评
      dialogVisible: false, //联网我们弹窗
      activeName: '1', //为什么学编程，默认选择
      IdeaIcons: [
        'el-icon-s-help',
        'el-icon-s-management',
        'el-icon-date',
        'el-icon-guide',
      ],
      SchoolIntroIcons: [
        'el-icon-office-building',
        'el-icon-alarm-clock',
        'el-icon-star-off',
      ],
      //关于我们
      aboutBannerList: [
        'https://scratch3.fun/homepage/images/footerwx/homesetfooterwximg-c6feccb5',
        'https://scratch3.fun/homepage/images/footerwx/homesetfooterwximg-c6feccb5',
        'https://scratch3.fun/homepage/images/footerwx/homesetfooterwximg-c6feccb5',
      ],

      //大咖推荐
      BignameData: [
        {
          id: '0001',
          name: '比尔盖茨',
          position: '微软创始人',
          says: '每个人都可以从编程学习中受益',
          imgUrl: [
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-1.png',
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-2.png',
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-3.png',
          ],
        },
        {
          id: '0002',
          name: '史蒂夫.乔布斯',
          position: '苹果公司创始人',
          says: '学习编程教你如何思考。',
          imgUrl: [
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-2.png',
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-3.png',
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-1.png',
          ],
        },
        {
          id: '0003',
          name: '奥巴马',
          position: '美国前总统',
          says: '编程教学如同识字一样，应成为基础教育的一部分。',
          imgUrl: [
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-3.png',
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-1.png',
            'https://lycheecode.scratch3.fun/homepage/images/resource/testimonial-2.png',
          ],
        },
      ],

      /***********以上数据默认************/

      //联系人
      ContantUs: {
        title: '萌萌老师',
        img_url:
          'https://scratch3.fun/homepage/images/footerwx/homesetfooterwximg-c6feccb5',
      },

      //顶部轮播图
      imageList: [],
      //校区数据
      homepage: [],

      //关于我们
      AboutInfo: {
        title_one: '关于我们',
        title_two: '欢迎来到五格殿下少儿编程学习中心',
        content:
          '五格殿下是中国知名少儿编程品牌，为5-16岁少儿提供完美的机器人编程课程方案。通过学习，孩子们可以创作做出各种酷炫的机器人和编程作品，与学科知结合，锻炼孩子们各项能力，让孩子站在时代的最前沿，领跑同龄人.',
        imgup_url:
          'https://lycheecode.scratch3.fun/homepage/images/aboutus/1.jpg',
        imgdown_url:
          'https://lycheecode.scratch3.fun/homepage/images/aboutus/2.jpg',
      },

      //课程体系
      CourseInfo: [],

      //教学理念
      //教学理念
      TeachingIdea: [],
      //校园简介
      SchoolIntroduce: {
        title_one: '校园简介',
        title_two: '优良的学习环境',
        contents: [
          {
            id: '0001',
            title: '商户名称',
            content: '天津市河西区徽州道五格殿下机器人学习中心',
          },
          {
            id: '0002',
            title: '商户名称',
            content: '天津市河西区徽州道五格殿下机器人学习中心',
          },
          {
            id: '0003',
            title: '商户名称',
            content: '天津市河西区徽州道五格殿下机器人学习中心',
          },
        ],
      },
      //师资力量
      TeacherList: [],

      //校园新闻
      NewsList: [],
      firstnews_img: '',
      firstnews_title: '',
      firstnews_content: '',
      firstnews_date: '',

      //学编程的好处
      LearnCodeList: [],

      //照片墙
      StudentList: [],

      //FOOTER数据
      FooterData: [],

      BlackList: ['hgedu', 'zhiyu'],
      gonglixiao: false,

      homepage_class: 'homepage',
    }
  },
  computed: {
    pages() {
      const pages = []
      this.TeacherList.forEach((item, index) => {
        const page = Math.floor(index / 4)
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })

      return pages
    },

    //少儿编程学习好处

    learncode_pages() {
      const pages = []
      this.LearnCodeList.forEach((item, index) => {
        const page = Math.floor(index / 4)
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })

      return pages
    },

    stu_pages() {
      const stu_pages = []
      this.StudentList.forEach((item, index) => {
        const page = Math.floor(index / 4)
        if (!stu_pages[page]) {
          stu_pages[page] = []
        }
        stu_pages[page].push(item)
      })

      return stu_pages
    },

    autoHeight() {
      let _w = document.documentElement.clientWidth || document.body.clientWidth
      return _w * 0.67 * 0.48 + 'px'
    },
  },
  watch: {
    NewsList() {
      this.firstnews_img = this.NewsList[0].img_url
      this.firstnews_title = this.NewsList[0].title
      this.firstnews_content = this.NewsList[0].content
      this.firstnews_date = this.NewsList[0].date
    },
  },
  created() { },
  mounted() {
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 10 ? date.month : '0' + date.month
    let newday = date.date > 10 ? date.date : '0' + date.date
    let newminutes = date.minutes < 10 ? '0' + date.minutes : date.minutes
    let newseconds = date.seconds < 10 ? '0' + date.seconds : date.seconds
    // 我需要的时间格式为 "yyyy-MM-dd HH:mm:ss" 有不一样的自己拼别的，都是字符串拼接
    this.newTime =
      date.year +
      '-' +
      newmonth +
      '-' +
      newday +
      ' ' +
      date.hours +
      ':' +
      newminutes +
      ':' +
      newseconds
    console.log(this.newTime, 11234)
    sessionStorage.setItem('cs', 123456)

    this.getAutoHeight_Top()
    getHomepage().then((res) => {
      console.log('校区首页')
      console.log(res)
      if (res.homepageData) {
        console.log('有校区信息')
        this.isschool = false
        this.imageList = res.homepageData.homepageBanner

        this.homepage = res.homepageData.homepage
        sessionStorage.setItem('homepage', this.homepage.is_show_copy_right)
        this.CourseInfo = res.homepageData.homepageSystem
        this.TeacherList = res.homepageData.homepageTeacher
        this.NewsList = res.homepageData.homepageNews
        this.LearnCodeList = res.homepageData.homepageWhyLearn
        this.StudentList = res.homepageData.homepageStu
        this.FooterData = res.homepageData.homepageFooterMatch
        this.off_time1 = res.schoolInfo.off_time
        sessionStorage.setItem('schoolInfo', JSON.stringify(res))

        for (let i = 0; i < this.BlackList.length; i++) {
          if (res.schoolInfo.domain == this.BlackList[i]) {
            this.gonglixiao = true
            console.log('这个学校是公立校')
            this.homepage_class = 'homepage_gonglixiao'
          }
        }
      } else {
        console.log('无校区信息')
        this.isschool = true
        this.$router.push({
          name: 'login',
        })
      }
      if (this.$store.state.user.token) {
        this.freshData()
        this.$store.dispatch('storeMethodCheckAccount') // 校验密码
      }
    })
    // this.$nextTick(() => {

    //   const swiperTop = this.$refs.swiperTop.swiper
    //   const swiperThumbs = this.$refs.swiperThumbs.swiper
    //   console.log(swiperTop, 45878);
    //   console.log(swiperThumbs, 45878);
    //   swiperTop.controller.control = swiperThumbs
    //   swiperThumbs.controller.control = swiperTop

    // })
    // let height = document.getElementById('leftTop')
    // console.log(height.offsetHeight, 458784);
    // console.log(sessionStorage.getItem('homepage'), 45748)
  },
  updated() {
    document.getElementsByClassName('header-menu-container')[0].style.display =
      'block'
  },

  methods: {
    closeTc() { },

    enter: function (i, ele) {
      console.log(ele)
      this.eleindex = i
    },
    out: function (i) {
      console.log(i)
      this.imgindex = -1
    },

    //刷新账号信息
    freshData() {
      this.$store.dispatch('freshUserData').then((res) => {
        console.log(res)
        if (res.identity === 1) {
          console.log(this.off_time1, 112341)
          let startTime = new Date(this.newTime) // 开始时间
          let endTime = new Date(this.off_time1) // 结束时间
          let usedTime = endTime - startTime // 相差的毫秒数
          let days = Math.floor(usedTime / (24 * 3600 * 1000)) // 计算出天数
          let leavel = usedTime % (24 * 3600 * 1000) // 计算天数后剩余的时间
          let hours = Math.floor(leavel / (3600 * 1000)) // 计算剩余的小时数
          let leavel2 = leavel % (3600 * 1000) // 计算剩余小时后剩余的毫秒数
          let minutes = Math.floor(leavel2 / (60 * 1000)) // 计算剩余的分钟数
          // return days + '天' + hours + '时' + minutes + '分';
          console.log(days + '天' + hours + '时' + minutes + '分', 11234)
          this.off_time = days + '天' + hours + '时' + minutes + '分'
          if (days <= '7') {
            // this.$message.warning({showClose: true,message:'距离到期还有' + days + '天' + hours + '时' + minutes + '分})
            this.$message({
              showClose: true,
              duration: 5000,
              message:
                '系统到期时间为\xa0' +
                this.off_time1.slice(0, 10) +
                '，' +
                ' 剩余使用时长' +
                days +
                '天' +
                '，' +
                '请尽快联系售后续费' +
                '！',
              type: 'warning',
            })
            // this.$notify({
            //   title: '到期提醒',
            //   message: '距离到期还有' + days + '天' + hours + '时' + minutes + '分',
            //   position: 'top-right',
            // });
          }
        }
      })
    },

    //轮播图自适应高度
    getAutoHeight_Top() {
      let _w = document.documentElement.clientWidth || document.body.clientWidth
      this.autoHeight_top = _w * 0.5625 + 'px'
      if (_w > 1200) {
        this.autoHeight_top_course = 1200 * 1.44 * 0.23 + 'px'

        this.autoHeight_teacher = 1200 * 1.6 * 0.23 + 'px'

        this.autoHeight_code = 1200 * 1.5 * 0.23 + 'px'

        this.autoHeight_photo = 1200 * 1.2 + 'px'
        this.autoHeight_about = 1200 * 0.3 + 'px'
      } else {
        this.autoHeight_top_course = ''

        this.autoHeight_teacher = ''

        this.autoHeight_code = ''

        this.autoHeight_photo = ''
        this.autoHeight_about = ''
      }
    },

    handleContantBtnClick() {
      this.dialogVisible = true
    },
    handleContantBtnClickC() {
      this.dialogVisible = false
    },

    goHome() {
      console.log('回到顶部')
      document.getElementById('home').scrollIntoView()
    },
  },
}
</script>

<style>
.img {
  position: absolute;
  left: 0;
}

/* .swiper-pagination-bullet {
  width: 200px;
  height: 65px;
  display: inline-block;
 
}
.swiper-pagination-bullet .swiper-pagination-bullet-active {
  color: #f00 !important;
} */

/* .swiper-pagination-bullet {
  width: 200px;
} */

.swiper-pagination {
  /* width: 300px; */
}

.swiper-container {
  position: relative;
  width: 90%;
  height: calc(100vw * 0.5 * 0.5);
}

.header-menu-container {
  border: 0px !important;
}

.homepage .el-card {
  border-radius: 20px;
}

.homepage .el-card__body {
  padding: 0px;
}

.el-collapse-item__header {
  font-size: 18px;
  color: #606266;
}

.el-collapse-item__content {
  font-size: 16px;
  color: #909399;
}
</style>

<style lang="scss" scoped>
.el-row {
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
}

.homepage {
  // background: url(https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/back-wrapper.png) center top no-repeat;
  background-size: 100%;
  width: 100%;
  height: 0;
}

.homepage_gonglixiao {
  background-size: 100%;
  margin-top: 5px;
}

.el-carousel__container {
  width: 100%;

  // height: 0;
  //padding-bottom: 47.5%;
}

.el-carousel--horizontal {
  overflow: hidden;
}

.el-carousel__item {
  border: 0px;
}

.contant-img {
  border-radius: 5px;
}

.carousel-img {
  width: 100%;
  height: 100%;
}

.el-carousel__arrow {
  background: #ff7162;
  color: #fff;
}

.el-carousel__arrow:hover {
  color: gray;
}

.container-content {
  position: absolute;
  width: 80%;
  top: 30%;
  left: 10%;
  height: 60%;
}

.carousel-desc1 {
  color: white;
  font-size: 50px;
  font-weight: bold;
}

.carousel-desc2 {
  color: white;
  font-size: 50px;
  font-weight: 600;
}

.carousel-desc3 {
  color: white;
  font-size: 30px;
  font-weight: 10;
}

.carousel-button {
  width: 200px;
  position: relative;
  margin-top: 40px;
  font-size: 20px;
  font-family: "M PLUS Rounded 1c", sans-serif;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #fff;
  line-height: 26px;
  text-transform: uppercase;
  cursor: pointer;
  text-align: center;
  transition: all 500ms ease;

  border-radius: 40px;
  background: #eed54f;
}

.el-dialog__header {
  text-align: left;
}

.contant-img {
  width: 100%;
}

//关于我们
.aboutImg {
  position: absolute;

  width: 97%;
  top: 7%;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 15px;
  overflow: hidden;
}

.about-us {
  width: 100%;
  height: 0;
  padding-bottom: 56.14%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/aboutBg.png")
    no-repeat;
  background-size: 101%;
  position: relative;

  //border: 1px solid red;

  .about-us-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1200px;
    margin: 0 auto;
  }

  .aboutList1 {
    width: 62.5%;
    padding-bottom: 32%;
    background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/aboutListBg.png")
      no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 30px;
    position: relative;
  }

  .aboutButton {
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
    cursor: pointer;
  }

  .aboutList {
    // padding-bottom: 30%;
    // padding: 20px;
    // padding: 40px 14px 15px 14px;
  }

  .about-us-title-wrapper {
    text-align: center;
    /* background: chocolate; */
    margin-top: 0.4%;
    height: 0;
    padding-bottom: 5%;
    padding-top: 2.5%;

    .about-us-title {
      color: white;
      font-size: 35px;
      font-weight: bold;
    }
  }
}

.about-us-left {
  position: inherit;
}

.about-img1-wrapper {
  float: right;
  margin-right: 20%;
  margin-top: 10%;
  width: 40%;
  height: 0;
  padding-bottom: 50%;
}

.about-img2-wrapper {
  float: right;
  margin-right: 40%;
  margin-top: -40%;
  width: 40%;
  height: 0;
}

.about-img1 {
  border-radius: 30px;
}

.about-img2 {
  border-radius: 30px;
  border: 15px solid #fff;
}

.about-us-right {
  margin-right: 10%;

  .about-carousel-button {
    position: relative;
    margin-top: 30px;
    font-size: 20px;
    font-family: "M PLUS Rounded 1c", sans-serif;
    padding: 20px 80px;
    background-color: white;
    line-height: 26px;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    text-align: center;
    transition: all 500ms ease;
    border-radius: 40px;
  }
}

.about-us-title-h5 {
  color: #606266;
  font-size: 17px;
  line-height: 26px;
  font-weight: 700;
  margin-bottom: 13px;

  margin-top: 100px;
}

.about-us-title-h1 {
  font-size: 35px;
  line-height: 50px;
  // font-family: "M PLUS Rounded 1c", sans-serif;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.about-us-title-p {
  line-height: 26px;
  color: #fff;
  font-size: 15px;
  margin-top: 30px;
  text-align: center;
  font-weight: 600;
  width: 62.5%;
  margin-left: auto;
  margin-right: auto;
}

.course-wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 50.77%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/subjectBg.png")
    no-repeat;
  background-size: 100%;
  position: relative;
  //border: 1px solid red;

  .course-wrapper-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1200px;
    margin: 0 auto;
  }

  /*课程体系*/
  .course-list-title-wrapper {
    text-align: center;

    .course-list-title {
      font-size: 40px;
      font-weight: 600;
      color: #fff;
    }
  }

  .course-list-left {
    .course-list-title-h5 {
      color: #606266;
      font-size: 17px;
      line-height: 26px;
      font-weight: 700;
      margin-bottom: 13px;
    }

    .course-list-title-h1 {
      font-size: 40px;
      line-height: 50px;
      font-family: "M PLUS Rounded 1c", sans-serif;
      font-weight: 700;
      color: #606266;
    }
  }

  .course-list-title-p {
    line-height: 26px;
    color: #fff;
    font-size: 15px;
    padding-right: 50px;
    margin-top: 30px;
    font-weight: 600;
  }

  .course-list-right {
    margin-top: 80px;
    padding-left: 10%;
    padding-right: 10%;

    .CarouselCourseInfo {
      border-radius: 20px;
    }

    .el-carousel__container {
      height: 400px;
    }

    .CarouselCourseInfo h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
    }

    .CarouselCourseInfo:nth-child(2n) {
      background-color: #fff;
    }

    .CarouselCourseInfo:nth-child(2n + 1) {
      background-color: #fff;
    }

    .course-title {
      font-size: 22px;
      line-height: 30px;
      font-weight: 700;
      color: #606266;
      padding-left: 30px;
      padding-top: 20px;
    }

    .course-info {
      font-size: 15px;
      color: #909399;
      line-height: 26px;
      font-weight: 400;
      padding-left: 30px;
    }

    .course-detail {
      width: 100%;
      height: 50px;
      margin-top: 10px;
      text-align: center;
      color: white;
      font-size: 15px;
      line-height: 40px;
    }
  }

  .course-img-wrapper {
    width: 100%;
  }

  .img-wrapper {
    overflow: hidden;
    width: 100%;
    height: 0;
    padding-bottom: 82%;
  }

  .course-img {
    width: 100%;
  }

  .img-wrapper:hover .course_desc {
    display: block;
  }

  .course_desc {
    color: white;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10;
    background: #201f1f9e;
    height: 375px;
    width: 96%;
    margin-left: 2%;
    margin-top: 12px;
    border-radius: 20px;
    display: none;

    .desc_txt {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0 auto;
      font-size: 16px;
    }
  }
}

.TeachingIdea {
  width: 100%;
  height: 0;
  padding-bottom: 53.2%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/PBLbg.png");
  background-size: 100% 100%;
  position: relative;
  //border: 1px solid red;
}

.TeachingIdea-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  margin: 0 auto;
}

.TeachingIdea-title-wrapper {
  text-align: center;

  .TeachingIdea-title {
    font-size: 40px;
    font-weight: 600;
    color: #fff;
  }

  .TeachingIdea-title-two {
  }
}

.TeachingIdea-right {
  padding-right: 15%;
  text-align: left;
}

.TeachingIdea-title-h5 {
  color: #606266;
  font-size: 17px;
  font-weight: 700;
  margin-top: 4%;
}

.TeachingIdea-title-h1 {
  font-size: 30px;
  font-family: "M PLUS Rounded 1c", sans-serif;
  color: #606266;
  margin-top: 5%;
  margin-left: -20%;
}

.TeachingIdea-title-p {
  line-height: 26px;
  color: #909399;
  font-size: 15px;

  margin-top: 30px;
}

.TeachingIdea-item {
  min-height: 100px;
  margin-bottom: 30px;
  margin-top: 30px;
}

.el-icon-s-help {
  font-size: 80px;
  color: rgb(247, 187, 23);
}

.el-icon-s-management {
  font-size: 80px;
  color: rgb(142, 95, 252);
}

.el-icon-menu {
  font-size: 80px;
  color: rgb(74, 171, 250);
}

.el-icon-guide {
  font-size: 80px;
  color: rgb(243, 100, 44);
}

.TeachingIdea-item-title {
  font-size: 22px;
  line-height: 30px;
  font-weight: 700;
  color: white;

  margin-top: 10px;
}

.TeachingIdea-item-desc {
  font-size: 15px;
  color: white;
  line-height: 26px;
  font-weight: 400;
  margin-top: 10px;
  padding-right: 50px;
}

.TeachingIdea-img1-wrapper {
  float: right;
  margin-right: 40%;
  width: 300px;
  height: 350px;
  background: lightblue;
  border-radius: 20px;
  opacity: 0.8;
}

.TeachingIdea-img2-wrapper {
  float: right;
  margin-right: 30%;
  margin-top: 30%;
  width: 50%;
  height: 0;
}

.TeachingIdea-img2 {
  border-radius: 30px;
}

/*校园简介*/
.school-wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 53.65%;
  //border: 1px solid red;

  .school-title-wrapper {
    text-align: center;
    /* background: chocolate; */
    margin-top: -3%;

    .school-title {
      color: white;
      font-size: 35px;
      font-weight: bold;
      margin-left: -38%;
    }
  }
}

.school-left {
  padding-left: 25%;
  padding-right: 10%;
  margin-top: 30%;
}

.school-left-title-h5 {
  color: #606266;
  font-size: 17px;
  line-height: 26px;
  font-weight: 700;
  margin-bottom: 13px;
}

.school-left-title-h1 {
  font-size: 40px;
  line-height: 50px;
  font-family: "M PLUS Rounded 1c", sans-serif;
  font-weight: 700;
  color: #606266;
}

.el-icon-office-building {
  color: white;
  font-size: 40px;
  width: 85px;
  height: 85px;
  line-height: 85px;
  text-align: center;
  border-radius: 50%;
}

.el-icon-alarm-clock {
  color: white;
  font-size: 40px;
  width: 85px;
  height: 85px;
  line-height: 85px;
  text-align: center;
  border-radius: 50%;
}

.el-icon-star-off {
  color: white;
  font-size: 40px;
  width: 85px;
  height: 85px;
  line-height: 85px;
  text-align: center;
  border-radius: 50%;
}

.detail-title {
  font-size: 22px;
  font-weight: 700;
  color: #606266;

  line-height: 50px;
}

.detail-content {
  font-size: 15px;
  color: #909399;
  line-height: 26px;
  font-weight: 400;
  padding-right: 50px;
}

.school-right {
  width: 100%;
  margin-left: 5%;
  margin-top: 26%;

  .school-img-wrapper {
    width: 100%;
    height: 0;
    padding-bottom: 65%;

    .school-img {
      width: 100%;
      border: 4px solid white;
    }
  }
}

/*师资介绍*/
.bgTeacher {
  width: 100%;
  height: 0;
  padding-bottom: 126%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/teacherBgPic.png")
    no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.bgSubject {
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/subjectBorder.png")
    no-repeat;
  background-size: 100% 100%;
}

.teacherBgButton {
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}

.bcBgButton {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}

.teacherName {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  width: 100%;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-top: -2px;
}

.teachers-wrapper-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  margin: 0 auto;
}

.teachers-wrapper-all {
  width: 100%;

  height: 0;
  // padding-bottom: 53%;
  padding-bottom: 49.5%;

  //border: 1px solid red;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/teacherBg.png")
    no-repeat;
  background-size: 101%;
  position: relative;

  .teachers-title-wrapper {
    text-align: center;
    /* background: chocolate; */
    margin-top: -1.2%;

    .teachers-title {
      color: white;
      font-size: 35px;
      font-weight: bold;
    }
  }

  .teachers-wrapper {
    text-align: center;
    margin-top: 2%;
  }

  .teacher-title-h5 {
    color: #606266;
    font-size: 17px;
    line-height: 26px;
    font-weight: 700;
    margin-bottom: 13px;
  }

  .teacher-title-h1 {
    font-size: 40px;
    font-weight: 600;
    color: #fff;
  }

  .teacher-list {
    margin-top: 50px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .teacher-image-wrapper {
    overflow: hidden;
    width: 100%;
    height: 0;
    padding-bottom: 126%;
  }

  .teacher-image {
    margin-top: 5%;
    width: 92%;
    border-radius: 26px;
  }

  .teacher_desc {
    color: white;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10;
    background: #201f1f9e;
    height: 310px;
    width: 94%;
    margin-left: 3%;
    margin-top: 12px;
    border-radius: 30px;
    display: none;

    .desc_txt {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      margin: 0 auto;
      font-size: 16px;
      padding: 10px;
    }
  }

  .bgTeacher:hover .teacher_desc {
    display: block;
  }

  .teacher-name {
    margin-top: 20px;
    font-size: 16px;
    color: #606266;
    font-weight: bold;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    height: 98px;
  }

  .teacher-desc {
    font-size: 14px;
    padding: 10px;
    color: #909399;
  }

  .teacher-swiper-item {
    height: 100%;
    padding-bottom: 0 !important;
  }
}

/*校园新闻*/

.news-wrapper-all {
  width: 100%;
  height: 0;
  padding-bottom: 45.1%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/newbg.png")
    no-repeat;
  background-size: 101%;
  position: relative;
  //border: 1px solid red;

  .news-wrapper-all-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1130px;
    margin: 0 auto;
  }

  .news-title-wrapper {
    text-align: center;
    padding-bottom: 50px;

    .news-title {
      font-size: 40px;
      font-weight: 600;
      color: #fff;
    }
  }

  .news-wrapper {
    margin-top: 2%;
    text-align: center;
  }

  .news-title-h5 {
    color: #606266;
    font-size: 17px;
    line-height: 26px;
    font-weight: 700;
    margin-bottom: 13px;
  }

  .news-title-h1 {
    font-size: 40px;
    line-height: 50px;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: 700;
    color: #606266;
  }

  .news-white-wrapper {
    width: 100%;
    background: white;
    border-radius: 20px;
    padding-bottom: 50px;
    padding-top: 50px;

    .news-wrapper-left {
      .news-img-wrapper {
        width: 100%;
        height: 0;
        padding-bottom: 52.4%;
        margin-top: 6%;

        .news-img {
          border-radius: 2px 2px 2px 2px;
          width: 100%;
        }
      }
    }

    .news-time {
      font-size: 16px;
      font-weight: 700;
      font-family: "M PLUS Rounded 1c", sans-serif;
      color: #606266;
    }

    .news-time-wrapper {
      text-align: left;
      padding-bottom: 30px;
    }

    .news-time-title {
      font-size: 22px;
      font-weight: 700;
      color: #606266;
      margin-top: 10px;
      padding-right: 50px;
      padding-left: 50px;
    }

    .news-time-desc {
      font-size: 15px;
      color: #909399;
      line-height: 26px;
      font-weight: 400;
      margin-left: 50px;
      padding-right: 50px;
    }

    .news-button {
      position: relative;
      margin-top: 10px;
      margin-left: 50px;
      font-size: 15px;
      font-family: "M PLUS Rounded 1c", sans-serif;
      padding: 17px 40px;
      color: #fff;
      line-height: 26px;
      font-weight: 700;
      text-transform: uppercase;
      cursor: pointer;
      text-align: center;
      transition: all 500ms ease;
      border: 0;
    }

    .news-wrapper-right {
      margin-right: 50px;
      margin-top: 10%;
      overflow-y: scroll;

      width: 100%;
      height: 0;
      padding-bottom: 52.4%;
    }
  }
}

/*为什么学编程呢*/
.whycode-wrapper-all {
  width: 100%;
  height: 0;
  padding-bottom: 49.8%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/bcWhybg.png")
    no-repeat;
  background-size: 101%;
  position: relative;
  //border: 1px solid red;
}

.whycode-wrapper-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  margin: 0 auto;
}

.whycode-title-wrapper {
  text-align: center;
}

.whycode-title {
  font-size: 40px;
  font-weight: 600;
  color: #fff;
}

.whycode-list {
  margin-top: 80px;
  padding-left: 30px;
  padding-right: 30px;
}

.whycode-image-wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 80%;
}

.bck {
  width: 100%;
  height: 0;
  padding-bottom: 81.5%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/bck.png")
    no-repeat;
  background-size: 100% 100%;
  position: relative;
  //padding:11px 10px 7px 10px;
}

.whycode-image {
  width: 92%;
  margin-left: 4%;
  margin-top: 11px;
  border-radius: 20px;
}

.whycode-name {
  margin-top: -10px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background-color: #07196d;
  padding: 48px 30px 30px 30px;
  border-radius: 10px;
}

.whycode-desc {
  font-size: 14px;

  color: #fff;
  text-align: center;
}

/*大咖推荐*/
.bigname-wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 40.2%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/tjbg.png")
    no-repeat;
  background-size: 101%;
  position: relative;
  //border: 1px solid red;

  .bigname-wrapper-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1200px;
    margin: 0 auto;
  }

  .bigname-title-wrapper {
    text-align: center;
  }

  .bigname-title {
    font-size: 40px;
    font-weight: 600;
    color: #fff;
  }

  .bigname-left {
  }

  .bigname-title-h5 {
    color: #606266;
    font-size: 17px;
    line-height: 26px;
    font-weight: 700;
    margin-bottom: 13px;
  }

  .bigname-title-h1 {
    font-size: 40px;
    line-height: 50px;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: 700;
    color: white;
  }

  .bigname-right {
    padding-right: 50px;
  }

  .bigname-carousel {
  }

  .bigname-desc {
    margin-top: 50px;
  }

  .bigname-carousel-wrapper {
    padding: 50px;
    border-radius: 30px;
    font-size: 15px;
    font-weight: 400;
    color: #606266;
    text-align: center;
  }

  .bigname-bg {
    text-align: center;
    margin-top: 20px;
  }

  .bigname-name {
    font-size: 20px;
    font-family: "M PLUS Rounded 1c", sans-serif;
    line-height: 30px;
    color: #606266;
    font-weight: 700;
    margin-bottom: 4px;
  }

  .bigname-say {
    font-size: 18px;
    line-height: 30px;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: 700;
    color: #909399;
  }

  .bigname-img {
    width: 40%;
  }

  .bigname-down {
    position: relative;
    margin-top: -20px;
    text-align: center;
    color: #606266;
    font-size: 30px;
  }
}

/*常见担忧*/
.bignamesay-wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 44.32%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/cjbg.png")
    no-repeat;
  background-size: 101%;
  position: relative;
  //border:1px solid red;

  .bignamesay-wrapper-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1200px;
    margin: 0 auto;
  }

  .bignamesay-title-wrapper {
    text-align: center;

    .bignamesay-title {
      color: white;
      font-size: 35px;
      font-weight: bold;
    }
  }

  .bignamesay-left {
  }

  .bignamesay-title-h5 {
    color: #606266;
    font-size: 17px;
    line-height: 26px;
    font-weight: 700;
    margin-bottom: 13px;
  }

  .bignamesay-title-h1 {
    font-size: 30px;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: 500;
    color: #606266;
  }

  .bignamesay-right-wrapper {
    width: 80%;
    margin-left: 10%;
    // background: white;
    border-radius: 20px;
    margin-top: 2%;

    padding-top: 10px;
    padding-bottom: 20px;

    .bignamesay-right {
      padding-right: 50px;
      margin-top: 2%;
    }

    .bignamesay-carousel {
    }

    .bignamesay-desc {
      margin-top: 20px;
    }

    .bignamesay-carousel-wrapper {
      padding: 50px;
      border-radius: 30px;
      font-size: 15px;
      font-weight: 400;
      color: #606266;
      text-align: center;
    }

    .bignamesay-bg {
      text-align: center;
      margin-top: 20px;
    }

    .bignamesay-name {
      font-size: 20px;
      font-family: "M PLUS Rounded 1c", sans-serif;
      line-height: 30px;
      color: #606266;
      font-weight: 700;
      margin-bottom: 4px;
    }

    .bignamesay-say {
      font-size: 18px;
      line-height: 30px;
      font-family: "M PLUS Rounded 1c", sans-serif;
      font-weight: 700;
      color: #606266;
    }

    .bignamesay-img {
      width: 40%;
    }

    .bignamesay-down {
      position: relative;
      margin-top: -20px;
      text-align: center;
      color: #909399;
      font-size: 30px;
    }
  }
}

/*学员照片*/

.photo-wrapper-all {
  width: 100%;
  height: 0;
  padding-bottom: 52.7%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/studentbg.png")
    no-repeat;
  background-size: 100%;
  position: relative;
  //border: 1px solid red;
}

.photo-wrapper-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  margin: 0 auto;
}

.photo-wrapper {
  text-align: center;
}

.photo-title-h1 {
  font-size: 40px;
  font-weight: 600;
  color: #fff;
  padding-bottom: 100px;
}

.bgquan {
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/studentquan.png")
    no-repeat;
  background-size: 100%;
  width: 250px;
  height: 250px;
  padding-top: 10px;
}

/*FOOTER*/
.footer {
  width: 100%;
  height: 350px;
  position: relative;
  background-color: rgb(22, 22, 22);
}

.footer-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  margin: 0 auto;
}

.footer-us-title {
  font-size: 22px;
  line-height: 28px;
  font-weight: 700;
  color: #fff;
  margin-left: 50px;
}

.footer-us-content {
  font-size: 14px;
  color: #666;
  line-height: 26px;
  font-weight: 400;
  margin-left: 50px;
  margin-top: 20px;
}

.footer-contant-link {
  margin-left: 50px;
  margin-top: 20px;
}

.el-link.el-link--default {
  // font-size: 0.12rem;
  color: #666;
  margin-top: 5px;
}

.el-link.el-link--default:hover {
  color: white !important;
}

.beian:hover {
  color: white !important;
}

.footer-contant-info {
  margin-left: 50px;
}

.footer-contant-content {
  margin-top: 20px;
  font-size: 14px;
  color: #666;
  line-height: 26px;
  font-weight: 400;
}

.footer-icon {
  padding-right: 5px;
}

.footer-qrcode-img {
  margin-top: 20px;
  width: 100px;
  height: 100px;
  border: 5px solid white;
  margin-left: 50px;
}

.copyright {
  text-align: center;
  margin-top: 50px;
}

.copyright-content {
  margin-left: 50px;
  font-size: 15px;
  color: #383838;
  line-height: 26px;
  font-weight: 400;
}

.TeachingIdea-item-wrapper {
  display: flex;
  flex-wrap: wrap;
}
</style>

<style>
.header-menu-container {
  border: 0px !important;
}

.el-collapse-item__header {
  font-size: 18px;
  color: #606266;
}

.el-collapse-item__content {
  font-size: 16px;
  color: #909399;
}

.swiper-img {
  width: 100%;
  object-fit: fill;
}

/*手风琴样式*/
.or-container {
  display: flex;
  width: 100%;
  /* padding: 4% 2%; */
  box-sizing: border-box;
  height: 100%;
}

.box:hover .newdesc {
  display: block;
}

.newdesc {
  color: white;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  background: #201f1f9e;
  height: 345px;
  width: 98%;
  margin-left: 1%;
  margin-top: 10px;
  border-radius: 20px;
  display: none;
}

.newdesc_txt {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 20px;
  margin: 0 auto;
  font-size: 16px;
}

.or-container:before {
  background-color: rgba(0, 0, 0, 0.4);
}

.box {
  flex: 1;
  transition: 0.5s;
  line-height: 0;
  position: relative;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/newsBorder.png")
    no-repeat;
  background-size: 100% 100%;

  margin: 5px;
}

.box > img {
  width: 100%;
  height: calc(100%);
  transition: 0.5s;

  position: relative;
  cursor: pointer;
  padding: 13px 12px 13px 12px !important;

  border-radius: 35px;

  box-sizing: border-box;
}

.eleactive > img {
  width: 100%;
  height: 100%;
  border-radius: 38px;
}

.wenb {
  width: 80%;
  position: absolute;
  left: 10%;
  bottom: 20px;
  color: #fff;
  border-radius: 25px;
  background-color: #201f1f9e;
  text-align: center;
}

.wenb div:nth-child(1) {
  /* width: 54px; */
  width: 80%;
  padding: 20px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.wenb div:nth-child(2) {
  width: 80%;
  padding: 0;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  /* font-weight: 600; */
  color: #ffffff;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.eleactive {
  flex: 1 1 40%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/newBorder.png")
    no-repeat;
  background-size: 100% 100%;
}

.imgStyle {
  /* padding: 20px 19px 20px 19px; */
  /* overflow: hidden; */
  height: 370px;
}

/* .eleactive>img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
} */

/*end*/

.about-index .content {
  margin-top: 20px;
  font-size: 16px;
  font-family: SourceHanSerifSC-Regular, SourceHanSerifSC;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  display: flex;
}

.about-index .content .leftd {
  width: 500px;
  height: 298px;
  /* background-color: pink; */
  overflow: hidden;
}

.about-index .fine-grained .content {
  /* background: #f2e6d1; */
  display: flex;
  justify-content: space-between;
}

.fine-grained .content .left {
  width: 100%;
  height: 380px;
  /* height: 189px; */
  /* background-color: pink; */
}

.fine-grained .content .right {
  width: 760px;
  height: 380px;
  background: #f2e5d1;
  border-radius: 10px;
  padding: 20px;
}

.fine-grained .content .right p {
  margin: 0px 0px 10px 0px;
  width: 69px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
}

.fine-grained .content .right div {
  width: 700px;
  height: 256px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  /* font-weight: 600; */
  color: #333333;
  line-height: 32px;
  text-indent: 28px;
}

.iconwn {
  vertical-align: middle;
  width: 34px;
  height: 33px;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/iconwn.png")
    no-repeat;
  background-size: 100%;
  float: left;
}

.colorTxt {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-left: 60px;
  line-height: 34px;
}

.colorTxt1 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  line-height: 34px;
}

.tcBg {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
}

.tc {
  width: 620px;
  height: 367px;
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  background: url("https://wugecdn.steam.fun/resources/static/homepage_v2/tc.png");
  margin-top: -184px;
  margin-left: -310px;
}

.mp {
  width: 130px;
  position: absolute;
  left: 23.5%;
  top: 41.7%;
}

.iconx {
  position: absolute;
  right: 3%;
  top: 3%;
  cursor: pointer;
}
</style>
<style scoped lang="scss">
@import "@/styles/indexMediaStyle.scss";
</style>